const driverShiftsTemplates = {
  table: {
    headers: {
      name: 'Nombre',
      shiftStart: 'Inicio del turno',
      shiftEnd: 'Fin del turno',
      breakStart: 'Inicio del descanso',
      breakEnd: 'Fin del descanso',
      breakNumberStart: 'Inicio del descanso {{num}}',
      breakNumberEnd: 'Fin del descanso {{num}}',
    },
    actions: {
      delete: 'Eliminar',
    },
    toolTip: {
      noPermission: 'No tienes permiso para realizar esta acción',
    },
  },
  deleteModal: {
    header: 'Eliminar',
    body: '¿Estás seguro de que deseas eliminar la(s) plantilla(s) de turno?',
  },
  deleteToast: {
    body: 'Plantilla de turno eliminada correctamente',
  },
  form: {
    title: 'Plantilla de turno',
    templateNameHeader: 'Nombre de la plantilla',
    displayName: 'Nombre para mostrar',
    templateInfoHeader: 'Información de la plantilla',
    shiftStart: 'Inicio del turno',
    shiftEnd: 'Fin del turno',
    breakStart: 'Inicio del descanso',
    breakEnd: 'Fin del descanso',
    addBreak: '+ Añadir descanso',
    overnightNote: 'Este es un turno nocturno',
    durationError: 'La duración del turno no puede exceder 23:59',
    breakOutsideShiftError: 'Los descansos deben estar dentro del horario del turno',
    footer: {
      create: 'Enviar',
      update: 'Guardar',
    },
  },
  create: {
    success: 'Plantilla de turno creada correctamente',
    error: 'No se pudo crear la plantilla de turno',
  },
  update: {
    success: 'Plantilla de turno actualizada correctamente',
    error: 'No se pudo actualizar la plantilla de turno',
  },
};

export default driverShiftsTemplates;
